import { MessageListSubscription } from './types';

export const getSourceMessageListSubscription = (messageListSubscriptions: MessageListSubscription[], sourceMessageListOid: number): MessageListSubscription | null => {
  return messageListSubscriptions.find(list => {
    return list.oid === sourceMessageListOid;
  }) || null;
};

export const getChangedMessageListSubscriptions = (
  currentMessageListSubscriptions: MessageListSubscription[],
  scratchMessageListSubscriptions: MessageListSubscription[]
): MessageListSubscription[] => {
  const changedLists: MessageListSubscription[] = [];

  scratchMessageListSubscriptions.forEach(messageList => {
    const currentMessageListSubscription = currentMessageListSubscriptions.find(list => {
      return messageList.oid === list.oid;
    });
    if (!currentMessageListSubscription) {
      return;
    }
    const isEqual = messageList.subscription.sms === currentMessageListSubscription.subscription.sms &&
      messageList.subscription.email === currentMessageListSubscription.subscription.email &&
      messageList.subscription.facebookMessenger === currentMessageListSubscription.subscription.facebookMessenger;
    if (currentMessageListSubscription && !isEqual) {
      changedLists.push(messageList);
    }
  });

  return changedLists;
};